import { useState, useEffect } from 'react';
import { useAuth, User } from 'oidc-react';
import { AuthContextProps } from 'oidc-react/build/src/AuthContextInterface';


export function useAuthUser() {
  const auth: AuthContextProps = useAuth();
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    const onUserLoaded = (user: User | null): void => {
      if (user && !user.expired) {
        setUser(user);
      } else {
        setUser(null);
      }
      setIsLoading(false);
    };

    // Subscribe to events
    auth.userManager.events.addUserLoaded(onUserLoaded);
    auth.userManager.events.addUserUnloaded(() => setUser(null));

    // Initial check in case the user is already loaded before the event listener is attached
    auth.userManager.getUser().then(onUserLoaded);

    // Cleanup
    return () => {
      auth.userManager.events.removeUserLoaded(onUserLoaded);
      auth.userManager.events.removeUserUnloaded(() => setUser(null));
    };
  }, []);

  return { user, isLoading };
}
